import { api } from "./api";

export const GET_ALL_SUPPORTS = async () => {
    const { data } = await api.get("/supports")
    return data.supports || [];
}

export const GET_SUPPORT = async (id: string) => {
    const { data } = await api.get(`/supports/${id}`)
    return data;
}

export const DELETE_SUPPORT = async (id: string) => {
    const { data } = await api.delete(`/supports/${id}`)
    return data;
}

export const CREATE_SUPPORT = async (params: any) => {
    const { data } = await api.post(`/supports`, params)
    return data;
}

export const UPDATE_SUPPORT = async (id: string, params: any) => {
    const { data } = await api.patch(`/supports/${id}`, params)
    return data;
}

